import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TransactionCard from "./processComponent/TransactionCard";
import { CmpDatePicker } from "../../Component/Common/ToolBox/ToolBox";
import dayjs from "dayjs";
import { ZatcaTransactionSummaryApi } from "./Action";
import { fAlertToast } from "../../Utility/Utilitys";
import { useSelector } from "react-redux";

const ZatcaTransactionSummary = () => {
  const navigate = useNavigate();

  const locations = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [transactionList, setTransactionList] = useState([]);
  const [filterState, setFilterState] = useState({
    dateFrom: dayjs().startOf("month").toDate(),
    dateTo: dayjs().toDate(),
    selectedLocations: locations,
  });

  const selectAllOption = { Uid: "", Name1: "Select All" };
  const optionsWithSelectAll = [selectAllOption, ...locations];

  const applyfilter = async () => {
    try {
      if (filterState?.selectedLocations?.length > 0) {
        const response = await ZatcaTransactionSummaryApi({
          StartDate: dayjs(filterState?.dateFrom).format("MM-DD-YYYY"),
          EndDate: dayjs(filterState?.dateTo).format("MM-DD-YYYY"),
          LocUIds: filterState?.selectedLocations
            ?.map((el) => el.Uid)
            .join(","),
        });
        if (response?.data) setTransactionList(response?.data?.data);
      } else {
        fAlertToast("FAILED", "Need to select atleast one location");
        return;
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  const handleCardClick = (transaction) => {
    const key = `zatca-transaction-${Date.now()}`;
    localStorage.setItem(key,JSON.stringify({ ...transaction, ...filterState }));
    window.open(`/ZatcaTransactionDetail?key=${key}`, "_blank");
  };


  const handleLocationChange = (event, newValue) => {
    if (newValue.some((item) => item.Uid === "")) {
      const isSelectAll =
        filterState?.selectedLocations?.length !== locations?.length;
      setFilterState((prev) => ({
        ...prev,
        selectedLocations: isSelectAll ? [...locations] : [],
      }));
    } else {
      setFilterState((prev) => ({
        ...prev,
        selectedLocations: newValue,
      }));
    }
  };

  useEffect(() => {
    applyfilter();
  }, []);

  return (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={{ xs: 2, sm: 3 }}>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePicker
            xLabelText={"From Date"}
            xValue={filterState?.dateFrom}
            xOnChange={(newValue) => {
              setFilterState((prev) => ({ ...prev, dateFrom: newValue?.$d }));
            }}
            xName={"dateFrom"}
            size="small"
            xFullWidth={true}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <CmpDatePicker
            xLabelText={"To Date"}
            xValue={filterState?.dateTo}
            xOnChange={(newValue) => {
              setFilterState((prev) => ({ ...prev, dateTo: newValue?.$d }));
            }}
            xName={"dateTo"}
            size="small"
            xFullWidth={true}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={9} sm={4.5} md={5} lg={4}>
          <Autocomplete
            multiple
            options={optionsWithSelectAll || []}
            disableCloseOnSelect
            getOptionLabel={(option) => option.Name1}
            value={filterState?.selectedLocations}
            onChange={handleLocationChange}
            isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
            renderOption={({ key, ...props }, option, { selected }) => {
              let isChecked =
                option.Uid === ""
                  ? filterState?.selectedLocations?.length === locations?.length
                  : filterState?.selectedLocations?.some(
                      (item) => item.Uid === option.Uid
                    );
              return (
                <li key={`${option.Uid}-${option.Name1}`} {...props}>
                  <Checkbox
                    size="small"
                    style={{
                      margin: "5px !important",
                      height: "20px !important",
                    }}
                    checked={isChecked}
                  />
                  {option.Name1}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                label="Locations"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    padding: "0px !important",
                    minWidth: "0px !important",
                  },
                  "& .MuiAutocomplete-input": {
                    padding: "7.5px 4px 7.5px 5px !important",
                  },
                }}
              />
            )}
            fullWidth
          />
        </Grid>
        <Grid item xs={3} sm={1.5} md={2} lg={1}>
          <Button onClick={applyfilter} size="small" variant="contained">
            Load
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} marginY={2}>
        {Array.isArray(transactionList) &&
          transactionList?.length > 0 &&
          transactionList?.map((transaction, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <TransactionCard
                data={transaction}
                onClick={() => handleCardClick(transaction)}
              />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default ZatcaTransactionSummary;
